import { Billboard } from "@react-three/drei";
import { degToRad } from "three/src/math/MathUtils";
import { animated as a } from "@react-spring/three";
import React, { useRef, useMemo } from "react";
import { types } from "@theatre/core";
import { extend } from "@react-three/fiber";
import { MeshLineGeometry, MeshLineMaterial } from "meshline";
import { Vector3 } from "three";

extend({ MeshLineGeometry, MeshLineMaterial });

const FactsAndFiguresMarker = ({ circleSegments = 3, color = "#FF7E88", spring, id, ...props }) => {
  const lineShader = useRef();

  const linePoints = useMemo(() => {
    return [new Vector3(0, 0.15, 0), new Vector3(0, props.lineHeight, 0)];
  }, []);

  const lineMaterial = useMemo(() => {
    var mat = new MeshLineMaterial({
      transparent: true,
      color: color,
      lineWidth: 0.015,
      depthTest: true,
      depthWrite: false,
    });

    const onBeforeCompile = (shader) => {
      shader.uniforms = { ...shader.uniforms, fadeIn: { value: 1 } };
      shader.fragmentShader =
        "uniform float fadeIn;\nfloat dist(vec2 p0, vec2 pf){return sqrt((pf.x-p0.x)*(pf.x-p0.x)+(pf.y-p0.y)*(pf.y-p0.y));}\n" +
        shader.fragmentShader;
      shader.fragmentShader = shader.fragmentShader.replace(
        `    #include <colorspace_fragment>
  }`,
        `#include <colorspace_fragment>
    gl_FragColor.a = clamp(gl_FragColor.a * .8 - pow(dist(vUV,vec2(0.,0.5)),.9),0.,1.);
    gl_FragColor.a = gl_FragColor.a * step(vUV.x, fadeIn);
  }`,
      );
      lineShader.current = shader;
    };

    mat.onBeforeCompile = onBeforeCompile;

    return mat;
  }, []);

  return (
    <a.group scale={props.style.scale} {...props}>
      <Billboard lockX lockZ>
        <group position={[0, 0.1, 0.1]}>
          <mesh rotation={[0, 0, circleSegments > 3 ? degToRad(-45) : degToRad(30)]} position={[0, 0.1, 0]}>
            <circleGeometry args={[props.size, circleSegments]} />
            <meshBasicMaterial color={color} />
          </mesh>
          <mesh position={[0, -0.05, 0]}>
            <meshLineGeometry attach="geometry" points={linePoints} />
            <primitive attach="material" object={lineMaterial} />
          </mesh>
        </group>
      </Billboard>
    </a.group>
  );
};

export default FactsAndFiguresMarker;
